import type { ReviewQueueQuery, ReviewQueueResponse } from '@fruuit/shared'
import type { QueryParams } from '../../api/client'
import { useApiQuery } from '../../api/hooks'

export const reviewKeys = {
  all: ['review'] as const,
  queue: (query: ReviewQueueQuery) => ['review', 'queue', query] as const,
}

/** `GET /review/queue` (S14, P-WF-005). */
export function useReviewQueue(query: ReviewQueueQuery) {
  const params: QueryParams = {}
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== '') params[key] = value as string | number
  }
  return useApiQuery<ReviewQueueResponse>(reviewKeys.queue(query), '/review/queue', {
    query: params,
    placeholderData: (previous) => previous,
  })
}
